import styled from 'styled-components';
import { zindex } from '@chegg-ui/theme';
export var LoadingWrapper = styled.div.withConfig({
  componentId: "sc-nommqk-0"
})(["display:flex;flex-direction:column;width:100%;align-items:center;height:100%;> div{flex:1;width:100%;z-index:", ";text-align:center;}"], zindex.sledgehammer);
export var LoadingInlineWrapper = styled(LoadingWrapper).withConfig({
  componentId: "sc-nommqk-1"
})(["position:relative;> div{padding:0 0 15px;}"]);
export var LoadingOverlayWrapper = styled(LoadingWrapper).withConfig({
  componentId: "sc-nommqk-2"
})(["position:absolute;> div{padding-top:30px;background:rgba(255,255,255,0.7);}"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/LoadingIndicator/styled.js
// module id = 4536
// module chunks = 11